import type { Json, PixelEvent } from "../types";
import { getAgentContext, getConsent } from "./context";
import { newEventId } from "./identity";
import { classifyDeviceType, hostFromUrl, parseUTM, trafficFromClickIds } from "./url";

export interface BuildEventInput {
  eventName: string;
  visitorId: string | null;
  sessionId: string;
  pageInstanceId: string;
  props?: Record<string, Json>;
}

export function buildEvent(input: BuildEventInput): PixelEvent {
  const w = window;
  const loc = w.location;
  const doc = w.document;

  const viewportWidth = w.innerWidth || doc.documentElement.clientWidth;
  const viewportHeight = w.innerHeight || doc.documentElement.clientHeight;
  const language = (navigator.language || "").slice(0, 32);
  const tz = (() => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    } catch {
      return "";
    }
  })();

  const referrer = doc.referrer || null;
  const utm = parseUTM(loc.search);
  const clickId = utm.source ? null : trafficFromClickIds(loc.search);

  return {
    v: 1,
    event_id: newEventId(),
    event_name: input.eventName,
    event_ts: new Date().toISOString(),
    visitor_id: input.visitorId,
    session_id: input.sessionId,
    page_instance_id: input.pageInstanceId,
    url: loc.origin + loc.pathname,
    path: loc.pathname,
    title: (doc.title || "").slice(0, 512),
    referrer,
    referrer_domain: hostFromUrl(referrer),
    utm,
    traffic: clickId
      ? { source: clickId.source, medium: clickId.medium, campaign: utm.campaign }
      : { source: utm.source, medium: utm.medium, campaign: utm.campaign },
    device: {
      viewport_width: viewportWidth,
      viewport_height: viewportHeight,
      device_type: classifyDeviceType(viewportWidth),
      language,
      timezone: tz,
    },
    agent_context: getAgentContext(),
    consent: getConsent(),
    props: input.props ?? {},
  };
}
